import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { dashboardService } from "@/services/DashboardService";
import type { DashboardQueryFilters } from "@/types/dashboard";

export type DashboardFilters = DashboardQueryFilters;

export const getDashboardQueryKey = (
  page: number,
  filters: DashboardQueryFilters,
  limit: number,
) => ["dashboard", page, filters, limit] as const;

interface UseDashboardParams {
  page: number;
  filters: DashboardFilters;
  limit: number;
}

export const useDashboardData = ({ page, filters, limit }: UseDashboardParams) => {
  return useQuery({
    queryKey: getDashboardQueryKey(page, filters, limit),
    queryFn: () => dashboardService.getDashboardData(page, filters, limit),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });
};